"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookieConfig = void 0;
exports.cookieConfig = {
    PULSE_COOKIE_KEY: '_pulse2data',
    TEST_COOKIE_KEY: '_pulse2test',
    ENV_COOKIE_KEY: '_pulse2env',
    USE_SECURE_COOKIES: true,
    USE_LOCALSTORAGE: false,
};
//# sourceMappingURL=cookie-config.js.map